import { ConvertToPersianNumbers } from "@/utils/utils";

interface PaginationProps {
  count: number;
  page: number;
  pageSize: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    page: number
  ) => void;
  onPageSizeChange?: any;
  consultantsList?: boolean;
}

const ChevronLeft = () => (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 19l-7-7 7-7"
    />
  </svg>
);

const ChevronRight = () => (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 5l7 7-7 7"
    />
  </svg>
);

const CustomPagination: React.FC<PaginationProps> = ({
  count,
  page,
  pageSize = 12,
  onPageChange,
}) => {
  const pageCount = Math.ceil(count / pageSize);

  const getPages = (): (number | "ellipsis-start" | "ellipsis-end")[] => {
    const pages: (number | "ellipsis-start" | "ellipsis-end")[] = [];

    if (pageCount <= 7) {
      for (let i = 0; i < pageCount; i++) {
        pages.push(i);
      }
      return pages;
    }

    pages.push(0);

    if (page > 2) {
      pages.push("ellipsis-start");
    }

    const start = Math.max(1, page - 1);
    const end = Math.min(pageCount - 2, page + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (page < pageCount - 3) {
      pages.push("ellipsis-end");
    }

    pages.push(pageCount - 1);

    return pages;
  };

  if (pageCount < 1) return null;

  return (
    <div className="flex justify-center items-center gap-3 mt-8">
      <button
        type="button"
        disabled={page === 0}
        onClick={(e) => onPageChange(e, page - 1)}
        className="w-10 h-10 rounded-full bg-[#F5F5F7] text-gray-500 flex items-center justify-center hover:bg-gray-200 transition disabled:opacity-40 cursor-pointer disabled:cursor-not-allowed"
      >
        <ChevronRight />
      </button>

      {getPages().map((item) => {
        if (item === "ellipsis-start" || item === "ellipsis-end") {
          return (
            <div
              key={item}
              className="w-10 h-10 cursor-default rounded-full bg-[#F5F5F7] text-gray-400 flex items-center justify-center font-medium"
            >
              ...
            </div>
          );
        }

        const active = item === page;

        return (
          <button
            type="button"
            key={item}
            onClick={(e) => onPageChange(e, item)}
            className={`w-10 h-10 cursor-pointer rounded-full flex items-center justify-center text-sm transition-all duration-200 ${active
              ? "bg-[#444CE7] text-white shadow-md"
              : "bg-[#F5F5F7] text-gray-500 hover:bg-gray-200"
              }`}
          >
            {ConvertToPersianNumbers(item + 1)}
          </button>
        );
      })}

      <button
        type="button"
        disabled={page === pageCount - 1}
        onClick={(e) => onPageChange(e, page + 1)}
        className="w-10 h-10 rounded-full bg-[#F5F5F7] text-gray-500 flex items-center justify-center hover:bg-gray-200 transition cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <ChevronLeft />
      </button>
    </div>
  );
};

export default CustomPagination;